import React, { Component } from 'react';
import axios from '../../axios-trips';
import classes from './About.css';
import packageJson from '../../package.alias.json';

class About extends Component {
    state = {
        database: null,
        isProduction: false,
        isTest: false,
        loading: true
    }

    componentDidMount() {
        this.fetchDatabaseInfo();
    }

    fetchDatabaseInfo = () => {
        axios.get('/api/v1/database-info')
            .then(response => {
                this.setState({
                    database: response.data.database,
                    isProduction: response.data.isProduction === 'true',
                    isTest: response.data.isTest === 'true',
                    loading: false
                });
            })
            .catch(error => {
                console.error('Failed to fetch database info:', error);
                this.setState({ loading: false });
            });
    }

    render() {
        const isProduction = this.state.isProduction || this.state.database === 'Board';
        const isTest = this.state.isTest || this.state.database === 'Board_test';
        const isLocal = !isProduction && !isTest;

        let databaseType = 'Невідома';
        let databaseIcon = '❓';

        if (isProduction) {
            databaseType = 'Робоча';
            databaseIcon = '⚠️';
        } else if (isLocal) {
            databaseType = 'Локальна';
            databaseIcon = '💻';
        } else if (isTest) {
            databaseType = 'Тестова';
            databaseIcon = '🧪';
        }

        return (
            <div className={classes.About}>
                <h1 className={classes.Title}>Про Програму</h1>

                <section className={classes.Section}>
                    <h2 className={classes.SectionTitle}>Інформація про Базу Даних</h2>
                    {this.state.loading ? (
                        <p>Завантаження...</p>
                    ) : this.state.database ? (
                        <div className={classes.DatabaseInfo}>
                            <p><strong>Тип бази даних:</strong> {databaseIcon} {databaseType}</p>
                            <p><strong>Назва бази даних:</strong> {this.state.database}</p>
                        </div>
                    ) : (
                        <p>Не вдалося завантажити інформацію про базу даних</p>
                    )}
                </section>

                <section className={classes.Section}>
                    <h2 className={classes.SectionTitle}>Версія Програми</h2>
                    <div className={classes.VersionInfo}>
                        <p><strong>Версія:</strong> {packageJson.version}</p>
                    </div>
                </section>

                <section className={classes.Section}>
                    <h2 className={classes.SectionTitle}>Технічна Інформація</h2>
                    <div className={classes.TechnicalInfo}>
                        <p>Ця сторінка містить технічну інформацію про програму Kanban UFC.</p>
                        <p>Додаткова інформація буде додана в майбутніх версіях.</p>
                    </div>
                </section>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/containers/About/About.js